<template>
  <div class ="graphContainer"
       style="width: 100%;height: 100%"
       ref="river"
       id="river"></div>
</template>

<script>

export default {
  name: "scholarInterestChart",
  props: [
    'data'
  ],
  data() {
    return {
      loading: false,
      resizeTimer: null,
      riverChart:null
    }
  },
  created() {
    if (this.data.data && Object.keys(this.data.data).length > 0 && this.data.data[0] !== 'empty') {
      // this.loading = true
      // this.empty = false
      this.$nextTick(()=>{
        this.drawChart()
      })
    }
  },
  watch: {
    'data':
        function() {
          if (this.data.data && Object.keys(this.data.data).length > 0 && this.data.data[0] !== 'empty') {
            // this.loading = true
            // this.empty = false
            this.drawChart()
          }
        }
  },
  methods:{
    drawChart(){
      // const fontColor = '#808080'
      // const fontSize = 12
      const that = this

      if (that.data.data && that.data.data[0] !== 'empty') {
        //初始化图表
        this.riverChart = this.$echarts.init(document.getElementById('river'));



        let data = that.data.data
        let legend = that.data.legend
        // let splitNum = this.getSplitNum()

        let option = {
          singleAxis: {
            type: 'value',
            max: 'dataMax',
            min: 'dataMin',
            minInterval: 1,
            bottom: '8%',
            top:'10%',
            axisTick: {},
            axisLabel: {
              formatter:function (val) {
                return val
              }
            },
            splitLine:{
              show:false
            }
          },
          tooltip: {
            trigger: 'axis',
            extraCssText: 'z-index:999;',
            confine: true,
            show: true,
            axisPointer: {
              type: 'line',
              snap: true,
              lineStyle: {
                color: 'rgba(0,0,0,0.2)',
                width: 1,
                type: 'solid'
              },
              label: {
                show: true,
                formatter: function (params) {
                  return params.value.toString()
                }
              }
            },
          },
          legend: {
            data: legend,
            top:'3%'
          },
          series: [
            {
              data: data,
              type: 'themeRiver',
              showBackground: true,
              backgroundStyle: {
                color: 'rgba(180, 180, 180, 0.2)'
              },
              emphasis: {
                itemStyle: {
                  shadowBlur: 20,
                  shadowColor: 'rgba(0, 0, 0, 0.8)'
                }
              },
              label: {
                show: false
              }
            }
          ]
        }
        this.riverChart.setOption(option)
        window.addEventListener('resize', () => {
          this.riverChart.resize();
        })
      }
      this.loading = false
    },
    /*getSplitNum() {
      return Math.min(Math.round(this.$store.state.window.screenWidth * 0.75 / 40), 10)
    },
    fixSplitNum(myChart) {
      const that = this
      that.resizeTimer = setTimeout(function(){
        let splitNum = that.getSplitNum()
        let option = {
          singleAxis: {
            splitNumber: splitNum,
          }
        }
        myChart.setOption(option)
        myChart.resize('auto')

      },100)
    }*/
  }
}
</script>

<style>
.graphContainer{
  width: 100%;
  height: 300px;
  margin: auto;
}
</style>
